
import state from './../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../zviz2/zviz/components/group';
import HeaderBlueprint from './header/main';
import FilterBlueprint from './filter/main';
import MainBlueprint from './main/main';
import TooltipBlueprint from './elements/tooltip';
import {extend} from './../zviz2/zviz/functions';
import config from '../config.js';
import {getColorPalette, rgbToHsl} from '../helpers/color.js';
//import {LifeCycle} from './../zviz2/zviz/cycle';

class Controller extends GroupController {
    init(renderer){
        super.init(renderer);

        // Setting theme colors. First fetch all available themes, then assign a unique color for all and
        // store it in the config. Before this call finishes the colors will not be available. At the moment
        // we do not trigger a refresh when this data comes in, so if this response is delayed we may end up
        // with no colors when the page initially loads. This should be quite rare, but ideally we want to
        // have a fix for that.
        fetch(config.root + 'amounts?aggregateBy=theme_category').then(
                (response) => {
                    response.json().then((result) => {
                        if(result && result.status === 'success'){
                            const themes = result.items ? result.items.theme_category : [];
                            if(themes){
                                const themeNames = themes.map((i) => (i.v)).sort();
                                const palette = getColorPalette(themeNames.length);
                                config.display.themeColors = themeNames.reduce((obj, theme, i) => {
                                    obj[theme.toLowerCase()] = rgbToHsl(palette[i]);
                                    return obj;
                                }, {});
                                config.display.themeColors.default = [10, 62, 67];
                                config.display.themeColors.other = [10, 62, 67];
                            }
                        }
                    });
                });
    }
}


let Blueprint = extend({
    type: Controller,
    properties: {
        style: {
            position: 'relative', 
            width: '100%',
            left: '0%'
        }
    },
    events: {  },
    children: [
        HeaderBlueprint,
        extend({
            properties: {
                style: {
                    maxWidth: '1138px',
                    margin: '0px auto',
                    position: 'relative'
                }
            },
            children: [
                (ctrl) => { if(state.get('renderSize') == 'large'){
                        return [
                            FilterBlueprint,
                            MainBlueprint,
                            extend({
                                properties: {
                                    style: { clear: 'both' }
                                }
                            }, Group)
                        ]
                    }else{
                        return [
                            MainBlueprint,
                            FilterBlueprint
                        ]
                    }
                }
            ]
        }, Group),
        TooltipBlueprint
    ]
}, Group)


export default Blueprint;
export {Controller, Blueprint};

